import React from 'react';
import { Avatar, Space, theme } from 'antd';

// Shared Card-title identity for the chronological sections: a numbered
// antd Avatar (step order the operator works through) + an icon, so every
// major section reads consistently. Collapsed sub-sections reuse the same
// icon+label shape but omit the step number (they are not part of the
// linear flow). Purely presentational — no logic lives here.
interface TransportFormSectionTitleProps {
  icon: React.ReactNode;
  label: string;
  step?: number;
}

const TransportFormSectionTitle: React.FC<TransportFormSectionTitleProps> = ({ icon, label, step }) => {
  const { token } = theme.useToken();

  return (
    <Space size={10} align="center">
      {step ? (
        <Avatar
          size={24}
          style={{ backgroundColor: token.colorPrimary, fontSize: 13, fontWeight: 600 }}
        >
          {step}
        </Avatar>
      ) : (
        <span style={{ color: token.colorTextSecondary, display: 'inline-flex' }}>{icon}</span>
      )}
      {step ? <span style={{ color: token.colorPrimary, display: 'inline-flex' }}>{icon}</span> : null}
      <span>{label}</span>
    </Space>
  );
};

export default TransportFormSectionTitle;
